import { CalEventFieldType } from '../constants/cal-event-field-type.js';
export function isMultilineTextField(field) {
    return (field.typeId === CalEventFieldType.TEXT &&
        field.config.multiline === true);
}
//# sourceMappingURL=is-multiline-text-field.js.map